import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from 'axios';
import { GetItem, RemoveItem } from "./storage";
import { StorageKey } from "../constants/constants";
import Swal from "sweetalert2";
const API_URL = `${process.env.REACT_APP_BASE_API_URL}`

const ApiInstance = axios.create({
    baseURL: API_URL,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
});

ApiInstance.interceptors.request.use(
    async (config) => {
        const token = await GetItem(StorageKey.TOKEN);
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        console.log("aqui error")
        console.log(error)
        return Promise.reject(error);
    }
);
ApiInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        console.log(error)
        if (!error.response) {
            console.error("Error de red o problema del servidor:", error.message);
            toast.error("Ocurrio un error, intente de nuevo o revise los datos proporcionados.", {
                position: "top-right",
                autoClose: 3000,
            });
            return Promise.reject(error);
        }

        const { status, data } = error.response;

        if (status === 401) {

            toast.error("Tu sesión ha expirado. Redirigiéndote al login.", {
                position: "top-right",
                autoClose: 4500,
            });

            Swal.fire({
                icon: "error",
                title: "Sesión Expirada",
                text: "Tu sesión ha expirado. Por favor, inicia sesión nuevamente.",
                timer: 3000,
                showConfirmButton: false,
            });


            // Limpia el token y redirige después de un tiempo
            setTimeout(async () => {
                await RemoveItem(StorageKey.TOKEN);
                await RemoveItem(StorageKey.USER);
                await RemoveItem(StorageKey.FORM_TYPE);
                window.location.href = "/";
            }, 3000);
        } else {
            // Manejo genérico para otros códigos de error
            console.error(`Error ${status}:`, data);

            toast.error(
                data.message || `Error ${status}: Ocurrió un problema inesperado.`,
                {
                    position: "top-right",
                    autoClose: 3000,
                }
            );
        }

        return Promise.reject(error);
    }
);

export default ApiInstance;

